import { Box, Typography, useTheme } from "@mui/material";

const RoleInfo = ({ role }) => {
  const theme = useTheme();
  return (
    <Box>
      <Typography variant="h4" gutterBottom color={theme.palette.text.primary}>
        {role?.name}
      </Typography>
      <Typography variant="h4" gutterBottom color={theme.palette.text.primary}>
        {role?.description}
      </Typography>
    </Box>
  );
};

export default RoleInfo;
